import * as angular from "angular";

angular
  .module('bringoz.admin.action-reasons')
  .config(actionReasonsConfig);

function actionReasonsConfig($stateProvider, moment) {

}
